/*eslint react-hooks/exhaustive-deps: "off"*/
/*eslint no-unused-vars: "off"*/
import React, { useCallback, useContext, useEffect, useMemo, useState} from "react";
import {Alert, Button, Descriptions, Spin, Tabs} from "antd";
import useRMateChart from "./useRMateChart";
import {getApiHost, getLastDomByClassName, numberWithCommas} from "../../../utils";
import Axios from "axios";
import loadJS from "load-js";
import MapPropsContext from "../MapPropsContext";
import useDebounce from "../../../utils/hooks/useDebounce";
import usePortal from "react-useportal";
import ChartPane from "./ChartPane";
import {
  dataReturnByDataType,
  layoutForChart1,
} from "./RMateChartPublicStatStationUtils";


const ICON_MAPPING = {
    '32': ['cls1', '기지국'],
    '85': ['cls2', '이동중계국'],
    '94': ['cls3', '간이무선국'],
    '44': ['cls4', '육상무선국'],
    '49': ['cls5', '이동국'],
    '92': ['cls6', '아마추어국'],
    '42': ['cls7', '의무선박국'],
    '41': ['cls8', '선박국'],
    '21': ['cls9', '고정국'],
    '35': ['cls10', '육상국'],
    '11': ['cls11', '지상파방송국'],
    '12': ['cls12', '실용화시험국(방송국용)'],
    '13': ['cls13', '위성방송국'],
    '15': ['cls14', '신고제외무선국'],
    '16': ['cls15', '지상파방송보조국'],
    '17': ['cls16', '발신전용휴대전화(CT-2)'],
    '18': ['cls17', '가입자회선용무선국'],
    '19': ['cls18', '위성방송보조국'],
    '22': ['cls19', '전송망'],
    '23': ['cls20', '종합유선방송국'],
    '24': ['cls21', '중계유선방송'],
    '25': ['cls22', '음악유선방송'],
    '27': ['cls23', '개인휴대전화(PCS)'],
    '28': ['cls24', '주파수공용무선전화(자가용)'],
    '29': ['cls25', '무선조정중계국'],
    '30': ['cls26', '무선조정이동국'],
    '31': ['cls27', '해안국'],
    '33': ['cls28', '항공국'],
    '34': ['cls29', '휴대기지국'],
    '36': ['cls30', '일반해안국'],
    '37': ['cls1', '무선데이타통신'],
    '38': ['cls2', '어업용해안국'],
    '40': ['cls3', '구명부기국'],
    '43': ['cls4', '비상위치지시용무선표지국'],
    '45': ['cls5', '항공기국'],
    '46': ['cls6', '의무항공기국'],
    '47': ['cls7', '휴대국'],
    '48': ['cls8', '선상통신국'],
    '50': ['cls9', '선박국대여'],
    '51': ['cls10', '무선방향탐지국'],
    '52': ['cls11', '무선표지국'],
    '53': ['cls12', '무선항행육상국'],
    '54': ['cls13', '무선항행이동국'],
    '55': ['cls14', '무선측위국'],
    '56': ['cls15', '무선항행국'],
    '57': ['cls16', '무선탐지육상국'],
    '58': ['cls17', '무선탐지이동국'],
    '59': ['cls18', '비상위치지시용위성무선표지국'],
    '61': ['cls19', '비상국'],
    '62': ['cls20', '표준주파수및시보국'],
    '63': ['cls21', '기상원조국'],
    '64': ['cls22', '구내무선국'],
    '65': ['cls23', '주파수공용간이무선국'],
    '66': ['cls24', '차량디지틀이동전화'],
    '67': ['cls25', '휴대디지틀이동전화'],
    '68': ['cls26', '차량/휴대디지틀이동전화'],
    '69': ['cls27', '위성휴대통신용무선국'],
    '70': ['cls28', '육상지구국'],
    '71': ['cls29', '우주국'],
    '72': ['cls30', '지구국'],
    '73': ['cls1', '선박지구국'],
    '74': ['cls2', '해안지구국'],
    '75': ['cls3', '이동지구국'],
    '76': ['cls4', '육상이동지구국'],
    '77': ['cls5', '항공지구국'],
    '78': ['cls6', '항공기지구국'],
    '79': ['cls7', '기지지구국'],
    '80': ['cls8', '일반지구국'],
    '81': ['cls9', '산업용'],
    '82': ['cls10', '통신용'],
    '83': ['cls11', '의료용'],
    '84': ['cls12', '차량이동가입무선전화'],
    '86': ['cls13', '휴대이동가입무선전화'],
    '87': ['cls14', '주파수공용무선전화'],
    '88': ['cls15', '생활무선국(CB)'],
    '89': ['cls16', '차량/휴대가입무선전화'],
    '90': ['cls17', '이동품질감시'],
    '91': ['cls18', '실험국'],
    '93': ['cls19', '실용화시험국(실험국용)'],
    '95': ['cls20', '고정수신국'],
    '96': ['cls21', '무선호출국'],
    '97': ['cls22', '무선조정국'],
    '98': ['cls23', '코드레스폰'],
    '99': ['cls24', '전파천문국'],
    // 'RD': ['cls25', '레이다펄스변조송신'],
    // 'TV': ['cls26', 'TV방송국'],
};

// 필요한 목록 : 선택한 주파수 리스트, 조건 리스트, 시도코드, 아이콘 매핑 등 배열
const RMateChartPublicStatStation = ({ clsList, sidoCode, searchYear, disabled }) => {

  const cmb_gubun_chart = "01";
  const [isInit, setIsInit] = useState(false);
  const chartProfile = window.CHART_PROFILE || "test";

  useEffect(() => {
    let chartUrlList = [
      `/js/chart/LicenseKey/${chartProfile}/rMateChartH5License.js`,
      "/js/chart/rMateIntegrationH5.js",
      "/js/chart/theme.js",
      "/js/chart/shCore.js",
      "/town_radiomap.js",
    ];
    loadJS(chartUrlList).then(() => {
      setIsInit(true);
    });
  }, []);

  const [visible, setVisible] = useState(false);
  const {
    widgetState,
    clickedPointIconObjects,
  } = useContext(MapPropsContext);

  // as-is의 데이터 통신 사용하기 - 지역별 정보
  const [tableDistrictData, setTableDistrictData] = useState();

    /*
    서버통신을 위한 쿼리스트링 제작
    '!422009375!,!422040625!' 모양
   */
  const settingString = (checkList) => {
    // as-is 의 문자열 만들기 모양 : "2G,3G,LTE"
    const customArray = checkList.map(checkpItem => {
      // return '!' + checkpItem.substr(0, 3) + checkpItem.substr(4, 7) + '!'
      return '!' + checkpItem.substr(0, 3) + '!'
    });
    return customArray.toString();
  };

  const {display_code_stats} = widgetState;

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState();
  const [parsedObject, setParsedObject] = useState({});

  useDebounce(() => {
    if (isInit) {
      setIsLoading(true);
      setError(null);
      setParsedObject({});

      const url = getApiHost() + '/gisToolView/getPublicStatStation.do';

      const formData = new FormData();
      formData.append('menuNo', '300630');
      formData.append('gisViewId', 'GIS_000003');
      formData.append('gisViewId', '');
      formData.append('whereMaster', 'AND A.PMS$RDS_STA_CD IN ( @02@,@00@,@01@ )');
      formData.append('cls_cd', settingString(clsList));
      //formData.append('frq_hz', settingString(frqList));
      formData.append('sheetTitle', '사용자정의 데이터');
      formData.append('fileName', '사용자 정의 데이터.xlsx');
      formData.append('searchSid', sidoCode);

      // 지역별 정보, 주파수별 정보를 얻어내는 통신을 한 데 묶어 통신(순서대로가져옴)
      Axios.all([
          Axios.post(url, formData)
        ]
      ).then(Axios.spread((districtResponse) => {
        // 지역별 데이터는 리스트, 최대, 간격을 DB에서 계산해서 가져옴.
        const districtData = districtResponse['data'];
        //const districtMax = districtData['maximum'];
        //const districtInterval = districtData['interval'];
        const districtList = districtData['rows'];

        // 테이블에 넣을 데이터를 먼저 세팅
        setTableDistrictData(districtList);
        // 차트에 쓰일 데이터는 0값을 제외함

        const chartDistrictData = dataZeroRemoveFn(districtList);

        setParsedObject({
          chartDistrictData
        });

      }))
      .catch(e => console.error(e))
      .finally(() => {
        setIsLoading(false);
      });
    }
  }, 2000,
  [isInit, clsList, sidoCode, searchYear, setIsLoading, setParsedObject]);

  // 오른쪽 상단 레이어 하나만 띄우기, 아이콘 클릭 시 차트 레이어 닫기
  useEffect(() => {
    if(clickedPointIconObjects && clickedPointIconObjects.length > 0){
        setVisible(false);
    }
  }, [visible, clickedPointIconObjects]);

  const {
    chartDistrictData
  } = parsedObject;

  const [activeTabInfo , setActiveTabInfo] = useState('chart1');
  const activeTabKey = useMemo(() => {
    return activeTabInfo;
  }, [activeTabInfo]);

  const onChangeTab = useCallback((keys) => {
    setActiveTabInfo(keys);
  }, []);

  useEffect(() => {
    setActiveTabInfo('chart1');
  }, [display_code_stats]);

  return useRMateChart({
    init: () => setIsInit(true),
    style: {minHeight: '540px'},
    disabled,
    children: (
      <div >
        {/*{isLoading && <Spin style={{position: 'absolute', left: '50%', top: '50%', zIndex: 1}} size={"large"}/>}*/}
        {isLoading &&
          <div style={{position: 'absolute', top: 55, zIndex: 1, height: '90%', width: '100%', backgroundColor: 'white'}}>
            <Spin size={"large"}>
              <Alert
                message="차트 로딩 중"
                description="선택한 무선국의 정보를 불러오는 중입니다.."
                type="info"
                showIcon
                style={{height: '470px'}}
              />
            </Spin>
          </div>
        }
        <Tabs type={"card"} activeKey={activeTabKey} onChange={onChangeTab}>
          <Tabs.TabPane tab="지역별 정보" key={"chart1"}>
              <div style={STYLE_CONTENT}>
                {error &&
                <Alert message={"데이터 로딩에 실패했습니다. 잠시 후 다시 시도해주세요."} type={"error"}/>
                }

                {!isLoading && tableDistrictData &&
                <Descriptions bordered
                              title={'총 ' + tableDistrictData.length + ' 개 지역의 ' +
                              numberWithCommas(tableDistrictData.reduce((prev, next) => prev + next.cnt, 0)) + ' 개 무선국'}
                              size={"small"}
                              column={3}>
                  {tableDistrictData.map(({gugun, cnt}) =>
                    <Descriptions.Item key={gugun} label={gugun}>{numberWithCommas(cnt)}</Descriptions.Item>
                  )}
                </Descriptions>
                }
              </div>
              <br/>
              <ChartPane data={chartDistrictData}
                         processor={() => chartDistrictData}
                         layoutProcessor={() => layoutForChart1(CHART1_LAYOUT_PROPS, {
                          cmb_gubun_chart, searchYear
                         })}
                       style={
                         chartDistrictData && chartDistrictData.length > 18
                           ? {height: chartDistrictData.length * 30}
                           : {height: 470}
                       }/>
          </Tabs.TabPane>
        </Tabs>
      </div>
    ),
  });
  }
;

const getLabelForYearMonth = (yearMonth) => {
  if (yearMonth) {
    if (yearMonth.length === 4) {
      return `${yearMonth}년`;
    } else if (yearMonth.length === 6) {
      return `${parseInt(yearMonth.substr(0, 4))}년`;
    }
  }
  return yearMonth;
};

const CHART1_LAYOUT_PROPS = {
  title: "무선국 수",
  xtitle: "무선국 수",
  ytitle: "지역명",
  chartType: "Multi Series Stacked Bar",
  layOutStyle: "Detail",
  masterName: "무선국 점유율",
  valueFixed: 0,
  //임의추가
  searchYear:2020,
};

//2020.06.01 : MHz 단위 표기 추가
const MHZ_HELPER = {
  position: 'relative',
  float: 'right',
  fontSize: '12px',
}

const CHART_PANE_STYLE = {
  position: 'absolute',
  padding: '14px',
  margin: '8px',
  background: 'rgba(255, 255, 255, 1)',
  right: 36,
  top: 76,
  width: '700px',
  height: '600px',
  overflowX: 'auto',
  overflowY: 'auto',
  border: '1px solid grey',
  zIndex: 1,
};

const STYLE_CONTENT = {
  height: '100%',
  marginBottom: '30px',
  // overflowY: 'scroll',
};

const STYLE_SUBMIT = {
  position: 'absolute',
  top: -10,
  right: 2,
  padding: '10px 12px',
};

const dataZeroRemoveFn = (dataList) => {
  if (dataList) {
    return dataList.filter(obj => obj.cnt !== 0);
  }
};


export default RMateChartPublicStatStation;